<template>
<el-dialog :class="['dashboard-fullscreen', dashboardTheme]" :visible.sync="visible" :append-to-body="true" :show-close="false" fullscreen :modal="false" center @open="opened" @close="closed">
  <el-row slot="title" type="flex" justify="space-between" align="middle" class="dashboard-fullscreen__header">
    <span class="dashboard-fullscreen__title">{{ title }}</span>
    <div class="dashboard-fullscreen__theme-btn">
      <div class="dashboard-icon-group mr-l9">
        <w-dashboard-theme-dropdown type="img"></w-dashboard-theme-dropdown>
        <w-map-button type="img" icon="btn-full-responsive" :toggle="true" :pressed="isResponsive" :tooltip="isResponsive ? '반응형 동작 중' : '반응형 미동작 중'" @onClick="onResponsiveClick"></w-map-button>
        <w-map-button type="img" icon="btn-full-close" :toggle="true" tooltip="전체화면 종료" @onClick="onFullScreenCloseClick"></w-map-button>
      </div>
    </div>
  </el-row>
  <div
    class="dashboard-fullscreen__content"
    :style="dashboardLayoutStyle"
  >
  <!-- 애니메이션, 그라데이션 배경 -->
  <w-particle-background :options="aniOptions" v-if="dashboardTheme === DashboardConst.THEME.PARTICLE"></w-particle-background>
  <w-gradient-background :options="aniOptions" v-if="dashboardTheme === DashboardConst.THEME.GRADIENT"></w-gradient-background>
    <div class="layout__area" style="height: calc(100% - 40px)">
      <transition name="dialog-fade">
        <grid-layout
          ref="gridLayout"
          :layout="currentLayout"
          :col-num="DashboardConst.GRID_LAYOUT_OPTION.COL_NUM"
          :margin="DashboardConst.GRID_LAYOUT_OPTION.MARGIN"
          :vertical-compact="DashboardConst.GRID_LAYOUT_OPTION.VERTICAL_COMPACT"
          :row-height="layoutRowHeight"
          :is-draggable="false"
          :is-resizable="false"
          @layout-updated="onLayoutUpdated">
          <grid-item
            v-for="layout in currentLayout"
            :key="layout.i"
            :class="[widgetCls(layout.widgetTemplId)]"
            :x="layout.x"
            :y="layout.y"
            :w="layout.w"
            :h="layout.h"
            :i="layout.i"
            :min-w="DashboardConst.GRID_LAYOUT_OPTION.MIN_W"
            :max-w="DashboardConst.GRID_LAYOUT_OPTION.MAX_W"
            :min-h="DashboardConst.GRID_LAYOUT_OPTION.MIN_H"
            :max-h="DashboardConst.GRID_LAYOUT_OPTION.MAX_H">
            <component :is="widgetView(layout)" :layout="layout"/>
          </grid-item>
        </grid-layout>
          <!-- <el-carousel
          ref="carousel"
          trigger="hover"
          height="calc(100% - 30px)"
          :autoplay="false"
          indicator-position="none"
          arrow="never"
          @change="onIndexItemClick">
          <el-carousel-item v-for="(item, index, key) in layoutData" :key="key" :name="`item${key}`">
          <grid-layout
          ref="gridLayout"
          :layout="item"
          :col-num="DashboardConst.GRID_LAYOUT_OPTION.COL_NUM"
          :margin="DashboardConst.GRID_LAYOUT_OPTION.MARGIN"
          :vertical-compact="DashboardConst.GRID_LAYOUT_OPTION.VERTICAL_COMPACT"
          :row-height="layoutRowHeight"
          :is-draggable="false"
          :is-resizable="false"
          :use-css-transforms="false"
          @layout-updated="onLayoutUpdated">
          <grid-item
          v-for="layout in item"
          :key="layout.i"
          :x="layout.x"
          :y="layout.y"
          :w="layout.w"
          :h="layout.h"
          :i="layout.i"
          :min-w="DashboardConst.GRID_LAYOUT_OPTION.MIN_W"
          :max-w="DashboardConst.GRID_LAYOUT_OPTION.MAX_W"
          :min-h="DashboardConst.GRID_LAYOUT_OPTION.MIN_H"
          :max-h="DashboardConst.GRID_LAYOUT_OPTION.MAX_H">
          <component :is="widgetView(layout)" :layout="layout"/>
        </grid-item>
      </grid-layout>
      </el-carousel-item>
      </el-carousel> -->
      </transition>
    </div>
    <el-row type="flex" justify="center" align="middle" class="dashboard-fullscreen__footer">
      <span :class="['dashboard-fullscreen__indicator c-pointer', activeIndex === index ? 'active' : '']" v-for="(value, key, index) in layoutData" :key="key" @click="onIndexItemClick(index)"></span>
    </el-row>
  </div>

  <!-- <el-row slot="footer" type="flex" justify="center" align="middle" class="dashboard-fullscreen__footer">
    <span :class="['dashboard-fullscreen__indicator c-pointer', activeIndex === index ? 'active' : '']" v-for="(value, key, index) in layoutData" :key="key" @click="onIndexItemClick(index)"></span>
  </el-row> -->
  <w-progress-timer ref="timer" @onIndexItemClick="onIndexItemClick"/>
</el-dialog>
</template>

<script>
import { GridLayout, GridItem } from 'vue-grid-layout';
import WProgressTimer from '@/views/dashboard/components/ProgressTimer';
import WParticleBackground from '@/views/dashboard/components/frame/ParticleBackground';
import WGradientBackground from '@/views/dashboard/components/frame/GradientBackground';
import WDashboardThemeDropdown from '@/views/dashboard/components/DashboardThemeDropdown';
import WMapButton from '@/views/topologymap/components/MapButton';

import { forEach, orderBy, cloneDeep, maxBy, filter, values } from 'lodash';

import DashboardConst from '@/constants/dashboard';
import Base from '@/mixins/dashboard/base';

export default {
  name: 'WGridDashboardFullscreenPopup',
  components: {
    GridLayout,
    GridItem,
    WProgressTimer,
    WParticleBackground,
    WGradientBackground,
    WDashboardThemeDropdown,
    WMapButton,
  },
  mixins: [Base],
  provide() {
    return {
      isFullScreenLayout: true,
    };
  },
  data() {
    return {
      DashboardConst,
      /**
       * Confirm 진행 중 여부
       * @type {Boolean}
       */
      conforming: false,
      /**
       * 타이틀 (대시보드명)
       * @type {String}
       */
      title: '',
      /**
       * 테마
       * @type {[type]}
       */
      theme: DashboardConst.THEME.WHITE,
      /**
       * 팝업창 오픈 여부
       * @type {Boolean}
       */
      visible: false,
      /**
       * 대시보드 레이아웃
       * @type {Array}
       */
      layoutData: {},
      /**
       * 현재 대시보드 레이아웃 인덱스
       * @type {Number}
       */
      activeIndex: 0,
      layoutRowHeight: 0,
      refreshTimer: 0,
      percent: 0,
      refreshFlag: false,
      aniOptions: {
        backgroundColor: '#2961b6',
        color: '#8bb9fc',
        gradientColors: ['#4367e4', '#25a3db', '#38d2cb', '#654fd9'],
      },
    };
  },
  computed: {
    widgetCls() {
      return (widgetTemplId) => `${widgetTemplId}`;
    },
    widgetView() {
      return (layout) => {
        let widgetTemplId;

        try {
          // 먼저 위젯 데이터에서 참조하고 없으면,
          widgetTemplId = this.dashboardWidget[layout.i].widgetTemplId;
        } catch (e) {
          try {
            // 레이아웃 정보를 참조한다.
            widgetTemplId = layout.widgetTemplId;
          } catch (e2) {
            // ignore
          }
        }

        return this.$store.getters.getWidgetViewComponent[widgetTemplId];
      };
    },
    /**
     * 현재 대시보드 레이아웃 인덱스에 해당하는 레이아웃 반환
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    currentLayout() {
      return this.layoutData[this.activeIndex] || [];
    },
    themeCls() {
      return this.theme === DashboardConst.THEME.BLACK ? 'theme_gradient' : 'theme_white';
    },
    getLayoutData() {
      return values(this.layoutData);
    },
    perPageCustom() {
      const width = window.innerWidth;
      return [[width, 1], [width * 2, 2]];
    },
    /**
     * 대시보드 레이아웃 스타일
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    dashboardLayoutStyle() {
      return {
        transform: this.isFullScale ? `scale(${this.dashboardScaleX}, ${this.dashboardScaleY})` : `scale(${this.dashboardScale})`,
        width: `${this.dashboardWidth}px`,
        height: `${this.dashboardHeight}px`,
        background: `${this.backgroundStyle}`,
      };
    },
    backgroundStyle() {
      let style = 'none';

      if (this.backgroundType === DashboardConst.BACKGROUND_TYPE.COLOR) {
        style = this.dashboardData.bgColor;
      } else if (this.backgroundType === DashboardConst.BACKGROUND_TYPE.IMAGE) {
        style = `url(${this.$store.getters.getImageUrlById(this.dashboardData.customimageId)})`;
      }

      return style;
    },
    backgroundType() {
      return this.dashboardData ? this.dashboardData.bgType : DashboardConst.BACKGROUND_TYPE.COLOR;
    },
  },
  watch: {
    isResponsive() {
      this.$nextTick(() => {
        if (this.visible) {
          // 2019.08.21: isResponsive 초기값 설정 시 fullScreenpopup이 오픈되어있지 않아 콘솔에러 발생으로 popup이 오픈되었을 경우에만 loadData 하도록 수정
          this.loadData();
        }
      });
    },
  },
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.GRID_FULL_SCREEN, this.open);
  },
  beforeDestroy() {
    this.close();
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.GRID_FULL_SCREEN, this.open);
  },
  methods: {
    getCurrentLayout(index) {
      return this.layoutData[index] || [];
    },
    /**
     * 데이터 초기화
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    initData() {
      this.title = '';
      if (!this.refreshFlag) {
        this.theme = (this.$store.getters.getIsCustomCtrlDashboard) ? DashboardConst.THEME.BLACK : DashboardConst.THEME.WHITE;
      }
      this.layoutData = {};
      this.activeIndex = 0;
      this.conforming = false;
      this.refreshTimer = cloneDeep(this.$store.state.dashboard.dashboardData.refreshTimer);
    },
    /**
     * 데이터 로드
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    loadData() {
      this.initData();
      this.title = this.dashboardData.dashboardName;

      // 레이아웃을 row 3개를 기준으로 분할한다.
      const layoutInfo = cloneDeep(this.$store.state.dashboard.dashboardData.layoutInfo);
      const layoutData = {};
      const maxRow = maxBy(layoutInfo, 'y');
      if (maxRow) {
        for (let i = 0; i <= (maxRow.y / 3); i += 1) {
          layoutData[i] = filter(layoutInfo, (layout) => {
            layout.i = String(layout.i);
            const y = i * 3;
            // 2019.11.26: 레이아웃 분할 시 각 행의 위치에서 표현해야하는 최대치보다 h가 높을 경우에 잘리는 현상 없도록 처리
            const item = layout.y >= y && layout.y <= (y + 2);
            if (item) {
              const newY = (layout.y - y);
              if (newY === 0 && layout.h > 3) {
                layout.h = 3;
              } else if (newY === 1 && layout.h > 2) {
                layout.h = 2;
              } else if (newY === 2 && layout.h > 1) {
                layout.h = 1;
              }
            }
            return item;
          });
        }
      }
      this.layoutData = layoutData;
      this.responseLayout();
      this.$nextTick(() => {
        this.initTimer();
      });
    },
    /**
     * 레이아웃 인덱스 변경
     * @author KangBonghun(toto1323)
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    onActiveChange(index) {
      this.activeIndex = index;
      // this.$refs.carousel.setActiveItem(`item${index}`);
      this.$nextTick(() => {
        this.responseLayout();
      });
    },
    /**
     * 반응형 레이아웃 조정
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    responseLayout() {
      this.$nextTick(() => {
        this.updateHeight();
        this.updateWidth();
      });
    },
    onIndexItemClick(newIndex) {
      const self = this;
      setTimeout(() => {
        self.onActiveChange(newIndex);
        this.$nextTick(() => {
          self.initTimer();
        });
      }, 300);
    },
    /**
     * 위젯 높이 조정
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    updateHeight() {
      const header = 73;
      const footer = 40;
      const yMargin = DashboardConst.GRID_LAYOUT_OPTION.MARGIN[1];
      const marginNum = 4;
      const rowNum = 3;
      const adjust = yMargin;

      const calcHeight = ((this.$el.offsetHeight - header - footer) - ((yMargin * marginNum) + adjust)) / rowNum;

      this.layoutRowHeight = calcHeight;
    },
    /**
     * 위젯 너비 조정
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    updateWidth() {
      const sortArr = orderBy(cloneDeep(this.$store.state.dashboard.dashboardData.layoutInfo), ['y', 'x'], ['desc', 'desc']);
      forEach(sortArr, (layout) => {
        let { i, x, y, h, w } = layout;

        if (!this.isResponsive || window.innerWidth > 1535) {
          // original width
        } else if (window.innerWidth > 1280) {
          i = layout.i;
          y = 0;
          h = layout.h;
          w = 2;
          if (layout.w === 1 || layout.w === 2) {
            x = layout.x === 0 || layout.x === 1 ? 0 : 2;
          } else if (layout.w === 3) {
            x = layout.x === 0 ? 0 : 2;
          } else if (layout.w === 4) {
            x = 0;
          }
        } else {
          i = layout.i;
          y = 0;
          h = layout.h;
          w = 4;
          x = 0;
        }
        // self.$refs.gridLayout[self.activeIndex].eventBus.$emit('dragEvent', 'dragend', i, x, y, h, w);
        // self.$refs.gridLayout[self.activeIndex].eventBus.$emit('resizeEvent', 'resizeend', i, x, y, h, w);
        this.$refs.gridLayout.eventBus.$emit('dragEvent', 'dragend', i, x, y, h, w);
        this.$refs.gridLayout.eventBus.$emit('resizeEvent', 'resizeend', i, x, y, h, w);
      });
    },
    layoutUpdate() {
      this.$refs.gridLayout.eventBus.isDragging = false;
      this.$refs.gridLayout.eventBus.layoutUpdate();
      // this.$refs.gridLayout[this.activeIndex].eventBus.isDragging = false;
      // this.$refs.gridLayout[this.activeIndex].eventBus.layoutUpdate();
    },
    /**
     * 전체화면 종료 확인
     * @author KangBonghun(toto1323)
     * @param  {[type]} evt [description]
     * @return {[type]}     [description]
     */
    onConfirmClose(evt) {
      if (this.visible && evt.keyCode === 27 && !this.conforming) {
        this.conforming = true;
        this.$confirm('전체화면을 종료하시겠습니까?', '확인', {
          confirmButtonText: '예',
          cancelButtonText: '아니오',
          confirmButtonClass: 'el-button--solid',
          closeOnPressEscape: false,
        })
          .then(() => {
            this.close();
          })
          .catch(() => {})
          .finally(() => {
            this.conforming = false;
          });
        // 2018.10.24 : msgUtil사용 시 closeOnPressEscape옵션 사용할 수 없어 유틸 사용안하도록 임시 조치
        // this.$confirm(...msgUtil.getBasicConfirmData('전체화면을 종료'))
        //   .then(() => {
        //     this.close();
        //   })
        //   .catch(() => {})
        //   .finally(() => {
        //     this.conforming = false;
        //   });
      }
    },
    onFullScreenCloseClick() {
      this.$confirm('전체화면을 종료하시겠습니까?', '확인', {
        confirmButtonText: '예',
        cancelButtonText: '아니오',
        confirmButtonClass: 'el-button--solid',
        closeOnPressEscape: false,
      })
        .then(() => {
          this.close();
        })
        .catch(() => {})
        .finally(() => {
          this.conforming = false;
        });
    },
    onLayoutUpdated() {
    },
    /**
     * 새로고침 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onRefreshClick() {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_LOAD);
    },
    /**
     * 전체화면 open 완료
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    opened() {
      window.addEventListener('resize', this.loadData);
      window.addEventListener('keyup', this.onConfirmClose);
      setTimeout(() => {
        this.$message('전체화면을 종료하려면 ESC를 누르십시오.');
        this.loadData();
        this.refreshFlag = true;
      }, 100);
    },
    /**
     * 전체화면 close 완료
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    closed() {
      window.removeEventListener('resize', this.loadData);
      window.removeEventListener('keyup', this.onConfirmClose);
      this.refreshFlag = false;
      this.initData();
      this.$refs.timer.initData();
      this.$refs.timer.stopTimer();
    },
    /**
     * 전체화면 open 요청
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    open() {
      this.visible = true;
      this.$store.dispatch('openFullScreenLayer');
      this.$store.commit('setDashboardFullScreen', true);
    },
    /**
     * 전체화면 close 요청
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    close() {
      this.visible = false;
      this.$store.dispatch('closeFullScreenLayer');
      this.$store.commit('setDashboardFullScreen', false);
    },
    initTimer() {
      const timer = this.$refs.timer;
      timer.stopTimer();
      timer.initData(this.activeIndex, this.getLayoutData.length - 1, this.refreshTimer, 200);
      this.$nextTick(() => {
        timer.startTimer();
      });
    },
    onResponsiveClick() {
      this.$store.commit('setResponsiveLayout', !this.isResponsive);
    },
  },
};
</script>
<style lang="scss">
.dashboard-fullscreen {
  .dashboard-icon-group {
    display: flex;
  }
  z-index: 400 !important;
  &__header {
    height: 73px;
    // background-color: #717785;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 25px 35px;
    padding-top: 32px;
  }
  &__title {
    color: #fff;
    font-size: 1.5rem;
    font-weight: 500;
    letter-spacing: -0.01em;
  }
  &__content {
    width: calc(100% + 28px);
    height: calc(100% + 14px);
    margin: -14px -14px 0 -14px;
    background-size: 100% 100% !important;
    .gradient-background,
    .particle-background {
        top: 73px;
        height: calc(100%  - 73px);
    }
  }
  &__theme-btn {
    /* font-size: 15px; */
    color: #ddd; //$selectedgray
  }
  &__theme-btn > span {
    vertical-align: middle;
    transition: color .5s ease;
    -webkit-transition: color .3s ease;
  }
  &__theme-btn > span.selected {
    color: #ffffff;
  }
  &__switch {
    margin: 0px 5px;
  }
  &__footer {
    padding-top: 4px;
  }
  &__indicator {
    width: 10px;
    display: inline-block;
    height: 10px;
    border-radius: 12px;
    background: rgba(198, 206, 231, 1);
    padding: 3px;
    margin: 0 3px;
  }
  &__indicator.active {
    background: rgba(150, 206, 100, 1);
  }

  .el-dialog{
    background-color: #e7e9ee;
    overflow: hidden;
    min-width: 1280px;

  }

  .el-dialog__header {
    padding: 0;

    .el-button--default {
      border-color: #fff !important;
    }
  }
  .el-dialog__body {
    box-sizing: border-box;

    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }
    .container {
      width: 100%;
    }
    .carousel-item > div {
      height: 100%;
    }


    .carousel {
        position: relative;
        overflow: hidden;
        width: 100%;
    }

    .carousel-container {
        list-style: none;
        overflow: hidden;
        padding: 0;
        margin: 0;
        width: 500%;
        transition: transform 0.3s cubic-bezier(.694, .0482, .335, 1);
    }

    .carousel-item {
        position: relative;
        float: left;
        width: 20%;
    }


    .carousel-pagination {
        list-style: none;
        position: absolute;
        bottom: 3%;
        left: 0;
        right: 0;
        width: 50%;
        padding: 0;
        margin: 0 auto;
        text-align: center;
        z-index: 10;
    }

    .carousel-bullet {
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #000;
        cursor: pointer;
        margin: 0 7px;
        border-radius: 50%;
        opacity: 0.5;
        transition-property: transform, opacity, background-color;
        transition-duration: 0.3s;
    }

    .carousel-bullet:hover {
        -webkit-transform: scale(1.3);
        transform: scale(1.3);
    }

    .carousel-bullet.active-bullet,
    .carousel-bullet.active-bullet:hover {
        opacity: 1;
        -webkit-transform: scale(1.3);
        transform: scale(1.3);
        background-color: #fff;
        cursor: default;
    }
    padding: 14px 14px 0px 14px;
    width: 100%;
    // height: calc(100% - 73px - 15px);
    // height: calc(100% - 73px - 40px);
    height: calc(100% - 73px);
    overflow-y: hidden;
    .v-carousel {
      // width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
    }
    .v-carousel-items {
      height: 100%;
      overflow: hidden;
    }
    .el-carousel {
      width: 100%;
      height: 100%;
      // &__container {
      //   width: 100%;
      //   height: 100%;
      // }
      &__indecator {
        .el-carousel__button {
          background: #d3d3d3;
        }
        &.is-active {
          .el-carousel__button {
            background: #7c7f8e;
          }
        }
      }
    }
  }
  .el-dialog__footer {
    /* padding: 0px 0px 24px 0px; */
    // padding: 0px;
    // height: 40px;
  }
}
// .theme_black {
//   .dashboard-fullscreen {
//     &__header {
//       background: #4f5668;
//       border-bottom: #656877;
//
//     }
//   }
//   .el-dialog{
//     background: #161f2e;
//   }
//   .vue-grid-item {
//     background-color: #4f5668;
//     -webkit-box-shadow: 0px 1px 2px #1d1e1f;
//     box-shadow: 0px 1px 2px #1d1e1f;
//   }
//   .el-table.popup {
//     background: none !important;
//   }
// }

.theme_gradient,
.theme_particle {
  .dashboard-fullscreen {
    &__header {
      background: rgba(28, 42, 64, 0.82);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/popup/GridDashboardFullscreenPopup.vue